import { render } from "./HomeComponent.vue?vue&type=template&id=75668e75&bindings={}"
import script from "./HomeComponent.ts?vue&type=script&lang=js"
export * from "./HomeComponent.ts?vue&type=script&lang=js"

import "./HomeComponent.css?vue&type=style&index=0&lang=css"
script.render = render

export default script